import $ from 'jquery';

const key = 'has_seen_alert_';

function Notification(element) {
  this.$element = $(element);
  this.click = $.proxy(this.click, this);
  this.$instance = this.getPost();
  // Exit if a notifcation post is not found.
  if (!this.$instance.length) return;
  // Proceed ->
  this.storageKey = this.createKey();
  if (!this.getVariable() && this.$instance.length) {
    this.listen();
    this.show();
  } else {
    this.hide();
  }
}

Notification.prototype = {
  getPost() {
    return this.$element.find('.node');
  },
  createKey() {
    const id = this.$instance.attr('id');
    return key + /(\d+)/.exec(id)[0];
  },
  getVariable() {
    return sessionStorage.getItem(this.storageKey) || false;
  },
  setVariable() {
    sessionStorage.setItem(this.storageKey, true);
  },
  click(event) {
    this.setVariable();
    event.stopPropagation();
    if ($(event.target).is('.block, .block-inner')) {
      event.preventDefault();
      this.hide();
    }
  },
  hide() {
    this.$element.removeClass('show').addClass('hide');
  },
  show() {
    this.$element.addClass('show');
  },
  listen() {
    this.$element.on('click', this.click);
  },
};

export default Notification;
